import ProcLayout from "components/common/ProcurementComps/ProcLayout";
import DataSection from "./DataSection";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useProcurementStore from "store/procurement_store";
import NetworkDataSection from "../NetworkSection";
import CommVaultSection from "components/CommVaultSection/CommVaultSection";
import SiteSection from "components/SiteSection/SiteSection";
import { getUserIdentity } from "helpers/auth";
import { IsProcurementCommsComponentEnable } from "helpers/cognitogroups";

const SizingSection = () => {
  const [searchParams] = useSearchParams();
  const PK = searchParams.get("PK");
  const stage_name = searchParams.get("stage");
  const { fetchProcurementData } = useProcurementStore((state) => ({
    fetchProcurementData: state.fetchProcurementData,
  }));
  const [isUserAllowed,setIsUserAllowed] = useState(false);
  useEffect(() => {
    console.log("stage_name", stage_name);
    fetchProcurementData(PK, stage_name);
    fetchUserIdentity(stage_name)
  }, [PK]);

  const fetchUserIdentity = async (stage_name) => {
      const userIdentity = await getUserIdentity();
      setIsUserAllowed(IsProcurementCommsComponentEnable(stage_name, userIdentity?.cognito_groups));
  
    };

  const StageComponent = ({ stageName }) => {
    switch (stageName) {
      case "Sizing":
        return <DataSection isUserAllowed={isUserAllowed}/>;
      case "Network":
        return <NetworkDataSection PK={PK} isUserAllowed={isUserAllowed}/>;
      case "CommVault":
        return <CommVaultSection isUserAllowed={isUserAllowed}/>;
      case "Site":
        return <SiteSection PK={PK} isUserAllowed={isUserAllowed}/>;
      case "CommVault_Network":
        return <NetworkDataSection PK={PK} isUserAllowed={isUserAllowed}/>;
      default:
        return <DataSection />;
    }
  };

  return (
    <>
      <ProcLayout isUserAllowed={isUserAllowed}>
        <StageComponent stageName={stage_name} isUserAllowed={isUserAllowed} />
      </ProcLayout>
    </>
  );
};

export default SizingSection;
